const IMAGE_HOST = 'https://images.alpinehomeair.com/';

// Imported exploded views are PartnerNet attachments on the inventory item,
// stored as `uploads/inventory_item/<id>/<SystemName>.<Extension>` in the
// private bucket; they are only reachable through the presigned FilePath the
// attachments endpoint returns.
export const isAttachmentPath = (stored) =>
  /^\/?uploads\//i.test(String(stored || ''));

const attachmentField = (attachment, name) => {
  const key = Object.keys(attachment || {}).find(
    (candidate) => candidate.toLowerCase() === name.toLowerCase()
  );
  return key ? attachment[key] : undefined;
};

const buildExplodedViewUrl = (stored, attachments = []) => {
  if (!stored) return null;
  const value = String(stored);
  if (/^https?:\/\//i.test(value)) return value;

  if (isAttachmentPath(value)) {
    const fileName = value.split('/').pop().toLowerCase();
    const match = (attachments || []).find(
      (attachment) =>
        `${attachmentField(attachment, 'SystemName')}.${attachmentField(
          attachment,
          'Extension'
        )}`.toLowerCase() === fileName
    );
    return match ? attachmentField(match, 'FilePath') || null : null;
  }

  return `${IMAGE_HOST}${value.replace(/^\//, '')}`;
};

export default buildExplodedViewUrl;
